
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonCheckbox
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import AutoFillSelect from '@/components/AutoFillSelect.vue';
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';

export default defineComponent({
  name: "dataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonCheckbox,
    AutoFillSelect
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref({});
    const breedTypes = ref([]);
    const selectedBreedType = ref<any>({});
    const dairies = ref([]);
    const selectedDairy = ref<any>({});

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating production data:', error);
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      breedTypes.value = await getBreedTypes();
      dairies.value = await getDairies();
      dataLoaded.value = true;
    });

    const getBreedTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/dairy-cattle-breeds/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getDairies = async () => {
      try {
        const response = await axiosInstance.get(`api/core/dairies/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/dairy-cattle-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/dairy-cattle-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const handleSelected = (option: any, item: any, field: string, update = false) => {
      item[field] = option ? option.id : null;
      if (field == 'majority_breed') {
        selectedBreedType.value = option;
      }
      if (field == 'dairy_object') {
        selectedDairy.value = option;
      }
      if (update) {
        updateData(companyId, item);
      }
    };


    return {
      translations,
      currentLanguage,
      data,
      breedTypes,
      selectedBreedType,
      dairies,
      selectedDairy,
      submitForm,
      handleSelected
    };
  },
});
